<template>
  <div>
    <div class="level">
      <div class="level-left">
        <h3 class="title is-3">Dashboard</h3>
      </div>
      <div class="level-right">
        <div class="select is-small">
          <select v-model="monthAndYear.month">
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
        &nbsp;
        <div class="select is-small">
          <select @change="yearHasChanged()" v-model="monthAndYear.year">
            <option value="2019">2019</option>
            <option value="2020">2020</option>
            <option value="2021">2021</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
            <option value="2025">2025</option>
            <option value="2026">2026</option>
            <option value="2027">2027</option>
            <option value="2028">2028</option>
            <option value="2029">2029</option>
          </select>
        </div>
      </div>
    </div>
    <hr />
    <div class="tile is-ancestor" v-if="!hasAdminPriv">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <WeeklyProfit
            :year="monthAndYear.year"
            :month="monthAndYear.month"
            :isAdaptive="isAdaptive"
          />
        </article>
      </div>
      <div class="tile is-parent">
        <article class="tile is-child box">
          <MonthlyProfit
            :year="monthAndYear.year"
            :month="monthAndYear.month"
            :isAdaptive="isAdaptive"
          />
        </article>
      </div>
    </div>
    <div class="tile is-ancestor" v-if="hasAdminPriv">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div v-if="isFetchingTop1PerMonth">
            <p class="has-text-centered">Loading...</p>
          </div>
          <table
            class="
              table
              is-bordered is-striped is-narrow is-hoverable is-fullwidth
            "
            v-if="!isFetchingTop1PerMonth"
          >
            <thead>
              <th>January</th>
              <th>February</th>
              <th>March</th>
              <th>April</th>
              <th>May</th>
              <th>June</th>
              <th>July</th>
              <th>August</th>
              <th>September</th>
              <th>October</th>
              <th>November</th>
              <th>December</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p v-if="top1PerMonth[0].user">
                    <b-tag type="is-info">{{ top1PerMonth[0].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[0].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[1].user">
                    <b-tag type="is-info">{{ top1PerMonth[1].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[1].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[2].user">
                    <b-tag type="is-info">{{ top1PerMonth[2].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[2].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[3].user">
                    <b-tag type="is-info">{{ top1PerMonth[3].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[3].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[4].user">
                    <b-tag type="is-info">{{ top1PerMonth[4].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[4].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[5].user">
                    <b-tag type="is-info">{{ top1PerMonth[5].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[5].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[6].user">
                    <b-tag type="is-info">{{ top1PerMonth[6].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[6].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[7].user">
                    <b-tag type="is-info">{{ top1PerMonth[7].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[7].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[8].user">
                    <b-tag type="is-info">{{ top1PerMonth[8].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[8].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[9].user">
                    <b-tag type="is-info">{{ top1PerMonth[9].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[9].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[10].user">
                    <b-tag type="is-info">{{ top1PerMonth[10].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[10].totalProfit | formatNumber }}</p>
                </td>
                <td>
                  <p v-if="top1PerMonth[11].user">
                    <b-tag type="is-info">{{ top1PerMonth[11].user }}</b-tag>
                  </p>
                  <p>{{ top1PerMonth[11].totalProfit | formatNumber }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </article>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <SalesAgentSummary
            :year="monthAndYear.year"
            :month="monthAndYear.month"
            :isAdaptive="isAdaptive"
          />
        </article>
      </div>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <AnnualBarGraph :year="monthAndYear.year" :isAdaptive="isAdaptive" />
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AnnualBarGraph from "../components/Dashboard/AnnualBarGraph";
import WeeklyProfit from "../components/Dashboard/WeeklyProfit";
import MonthlyProfit from "../components/Dashboard/MonthlyProfit";
import SalesAgentSummary from "../components/Dashboard/SalesAgentSummary";
import VueJWT from "vuejs-jwt";
import axios from "axios";
import AuthService from "../_services/auth";
import numeral from "numeral";

Vue.filter("formatNumber", function (value) {
  if (!value) return 0;
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});
Vue.use(VueJWT);
const authService = new AuthService();

export default {
  name: "home",
  components: {
    AnnualBarGraph,
    WeeklyProfit,
    MonthlyProfit,
    SalesAgentSummary,
  },
  created() {
    this.getCurrentMonthAndYear();
    var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
    this.role = decodedToken.role;
    if (decodedToken.role === "Delivery Staff") {
      this.$router.push({
        name: "List of Delivery",
        params: {
          page: parseInt(1),
          pageSize: 10,
          searchQuery: "",
        },
      });
    } else if (decodedToken.role === "Technical Staff") {
      this.$router.push({
        name: "List of Ticketing for Item",
        params: {
          page: parseInt(1),
          pageSize: 10,
          searchQuery: "",
          sow: "all",
          itemType: "all",
          progressStat: "all",
        },
      });
    } else {
      // if (decodedToken) {
      //   if (decodedToken.exp < new Date().getTime() / 1000) {
      //     const tokens = {
      //       token: localStorage.getItem('token'),
      //       refreshToken: localStorage.getItem('refreshToken')
      //     }
      //     // Function that will be called to refresh authorization
      //     const refreshAuthLogic = failedRequest =>
      //       axios.post(`api/token/refresh`, tokens).then(response => {
      //         localStorage.setItem('token', response.data.token)
      //         localStorage.setItem('refreshToken', response.data.refreshToken)
      //         failedRequest.response.config.headers['Authentication'] =
      //           'Bearer ' + response.data.token
      //         return Promise.resolve()
      //       })
      //     // Instantiate the interceptor (you can chain it as it returns the axios instance)
      //     createAuthRefreshInterceptor(axios, refreshAuthLogic)
      //     axios.interceptors.request.use(request => {
      //       request.headers['Authorization'] = `Bearer ${this.getToken()}`
      //       return request
      //     })
      //   }
      // }
    }
  },
  data: () => ({
    monthAndYear: {},
    role: "",
    isAdaptive: false,
    hasAdminPriv: authService.hasAdminPriv(),
    top1PerMonth: [],
    isFetchingTop1PerMonth: false,
  }),
  methods: {
    yearHasChanged() {
      this.getTop1UserPerMonthInAyear();
    },
    getTop1UserPerMonthInAyear() {
      this.isFetchingTop1PerMonth = true;
      axios
        .get(
          `api/dashboard/get-top-1-user-per-month-in-a-year/${this.isAdaptive}/${this.monthAndYear.year}`
        )
        .then((response) => {
          this.isFetchingTop1PerMonth = false;

          this.top1PerMonth = response.data;
        })
        .catch((error) => {
          this.isFetchingTop1PerMonth = false;
          console.log(error);
        });
    },
    getCurrentMonthAndYear() {
      axios
        .get(`api/settings/current-month-year`)
        .then((response) => {
          this.monthAndYear = response.data;
          this.getTop1UserPerMonthInAyear();
        })
        // eslint-disable-next-line no-console
        .catch((error) => console.log(error));
    },
  },
  watch: {
    monthAndYear() {
      this.getTop1UserPerMonthInAyear();
    },
  },
};
</script>
